(() => {
  const isGiftingPage = () => window.location.pathname.includes('/pages/o-presente-perfeito');

  const apply = () => {
    if (!document.body || !isGiftingPage()) return;

    document.querySelectorAll('h1,h2,h3,p,a,span,summary').forEach((el) => {
      if (el.children.length === 0 && el.textContent.trim().toUpperCase() === 'POR ORÇAMENTO') {
        el.textContent = 'POR VALOR';
      }
      if (el.children.length === 0 && el.textContent.trim() === 'Escolhe pelo orçamento') {
        el.textContent = 'Por valor';
      }
    });

    document.querySelectorAll('p').forEach((el) => {
      if (el.children.length === 0 && el.textContent.includes('pelo orçamento que tens em mente')) {
        el.textContent = el.textContent.replace('pelo orçamento que tens em mente', 'pelo valor que tens em mente');
      }
    });

    const footer = document.querySelector('footer, #shopify-section-footer, .shopify-section-group-footer-group');
    if (footer && !document.querySelector('.omnia-gift-benefits')) {
      const section = document.createElement('section');
      section.className = 'omnia-gift-benefits';
      section.setAttribute('aria-label', 'Vantagens para oferecer OMNIA');
      section.innerHTML = `
        <div class="omnia-gift-benefits__inner">
          <div class="omnia-gift-benefit">
            <p class="omnia-gift-benefit__title">PRONTO A OFERECER</p>
            <p class="omnia-gift-benefit__copy">Escolhe a opção presente no carrinho.</p>
          </div>
          <div class="omnia-gift-benefit">
            <p class="omnia-gift-benefit__title">ENTREGA EM 3 DIAS ÚTEIS</p>
            <p class="omnia-gift-benefit__copy">Exceto peças personalizadas ou com indicação de prazo superior.</p>
          </div>
          <div class="omnia-gift-benefit">
            <p class="omnia-gift-benefit__title">TALÃO SEM PREÇO</p>
            <p class="omnia-gift-benefit__copy">Disponível para encomendas destinadas a oferta.</p>
          </div>
        </div>
      `;
      footer.insertAdjacentElement('beforebegin', section);
    }
  };

  document.addEventListener('DOMContentLoaded', apply, { once: true });
  document.addEventListener('shopify:section:load', apply);
  window.addEventListener('pageshow', apply);
  setTimeout(apply, 300);
})();